import { Typography } from "@mui/material"
import LogIcon from '@mui/icons-material/ReceiptLong'
import Box from "@mui/material/Box"
import { alpha, useTheme } from "@mui/material/styles"

export const NoLogs = () =>
{
  const theme = useTheme()
  return(
    <Box sx={styles.container(theme)}>

      <LogIcon style={styles.icon} />
      <Typography fontWeight="700" variant="subtitle1" color="textPrimary">Looks like there's no logs for that time range</Typography>
      <Typography variant="body2" color="textSecondary">Try adjusting the time range filter to look back further</Typography>

    </Box>
  )
}

const styles = {
  container: (theme: any) => ({
    height: '50vh',
    justifyContent: 'center',
    flex: 1,
    textAlign: 'center',
    alignItems: 'center',
    flexDirection: "column",
    display: 'flex',
    borderRadius: "14px",
    border: `1px dashed ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.12 : 0.45)}`,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.45),
  }),
  icon: {
    height: 128,
    width: 128,
    alignSelf: 'center',
    color: "grey"
  }
}
